module.exports = __webpack_public_path__ + "img/404Mobile.64e67e5e.png";